export type LernformIcon =
  | 'wbsuche-icon-request'
  | 'wbsuche-icon-fulltime'
  | 'wbsuche-icon-parttime'
  | 'wbsuche-icon-weekend'
  | 'wbsuche-icon-distance'
  | 'wbsuche-icon-elearning'
  | 'wbsuche-icon-block'
  | 'wbsuche-icon-inhouse'
  | 'wbsuche-icon-digital-tag'
  | 'wbsuche-icon-fernunterricht-tag'
  | 'wbsuche-icon-kombiniert-tag'
  | 'wbsuche-icon-praesenz-tag';

const icons: { [key: number]: LernformIcon } = {
  0: 'wbsuche-icon-request',
  1: 'wbsuche-icon-fulltime',
  2: 'wbsuche-icon-parttime',
  3: 'wbsuche-icon-weekend',
  4: 'wbsuche-icon-distance',
  5: 'wbsuche-icon-elearning',
  6: 'wbsuche-icon-block',
  7: 'wbsuche-icon-inhouse'
};

export type LernformKategorie = 'praesenz' | 'digital' | 'kombiniert' | 'fern';

const neueLernformenTag: { [key in LernformKategorie]: LernformIcon } = {
  praesenz: 'wbsuche-icon-praesenz-tag',
  digital: 'wbsuche-icon-digital-tag',
  kombiniert: 'wbsuche-icon-kombiniert-tag',
  fern: 'wbsuche-icon-fernunterricht-tag'
};

const neueLernformen: { [key: number]: LernformKategorie } = {
  1: 'praesenz',
  2: 'digital',
  3: 'kombiniert',
  4: 'fern'
};

export function getLernformKategorie(id: number): LernformKategorie | undefined {
  const kategorie = Math.floor(id / 100);
  return neueLernformen[kategorie];
}

export function getIconByUnterrichtsformId(id: number): LernformIcon {
  if (icons[id]) {
    return icons[id];
  }
  const lernformKategorie = getLernformKategorie(id);
  return lernformKategorie ? neueLernformenTag[lernformKategorie] : icons[0];
}
